export function formatSecondOpinionOutboundMessage(
  content: string,
  isSecondOpinionActive: boolean,
): string {
  const trimmed = content.trim();
  if (!trimmed || !isSecondOpinionActive) {
    return trimmed;
  }
  return `/advisor-proposal-review ${trimmed}`;
}
